import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { RekbotsService } from '../../../services/rekbots.service';
import { MatButtonModule } from '@angular/material/button';
import { NotificationService } from '../../../services/notification.service';
import { Rekbot } from '../../../models/rekbot.model';
import { RekbotFormComponent } from './rekbot-form/rekbot-form.component';

@Component({
  selector: 'app-edit-rekbot',
  imports: [
    RekbotFormComponent, MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './edit-rekbot.component.html',
  styleUrl: './edit-rekbot.component.css',
  standalone: true,
})
export class EditRekbotComponent implements OnInit {

  elementId: number;
  rekbot:Rekbot = {
    id: 0,
    serial_no: "",
    ipv4: "",
    port: 0,
    gps_device_id: "",
    status: 0,
    status_new: 0,
    namedStatus: "",
    organization_id: 0
  };;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private rekbotsService: RekbotsService,
    private notificationService: NotificationService,
    
  ) {
    this.elementId = 0;
  }

  ngOnInit(): void {
    this.elementId = this.route.parent?.snapshot.params['rekbotId'];
    console.log("id elemnetu:", this.elementId);
    

  //   if (this.elementId) {
  //     this.rekbotsService.fetchRekbot(this.elementId)
  //       .subscribe({
  //         next: (data: any) => {
  //           this.rekbotsService.setRekbot(data);
  //           this.rekbot = data.rekbot as Rekbot;
  //         },
  //         error: (error: any) => {
  //           console.error(error);
  //         }
  //       });
  //   }
  }

  // onSubmit() {
  //   console.log("submit")
  // }

}
